import { maxLength, propertyMapping, required } from '@hakla/typed-forms'
import { PostUpdate } from '@/business/post/models/post-update'
import { maxLengthHtml } from '@/shared/forms/max-length-html'

export interface EditablePostForm {
  content: string
  title: string
}

export function editablePostFormMapping() {
  return propertyMapping<PostUpdate, EditablePostForm>(({ generic }) => {
    return {
      content: generic('content').validations(required, maxLengthHtml(2500)),
      title: generic('title').validations(maxLength(100)),
    }
  })
}
